import { useGetCellStockDeliveryQuery } from "../../store/api/generated/stock-request-api";
import { isNullish } from "../../lib/util/common-util";
import { useMemo } from "react";
import {
  cellStockDeliveryMeta,
  CellStockDeliverySaved,
} from "../../lib/object/entity/cell-stock-delivery";

export function useAppGetCellStockDeliveryQuery(
  arg: Parameters<typeof useGetCellStockDeliveryQuery>[0],
  options?: Parameters<typeof useGetCellStockDeliveryQuery>[1],
  skipOptionalValidations = true, // get系は、skipOptionalValidationsのデフォルトはtrueとする。
): {
  data: CellStockDeliverySaved | null;
  refetch: ReturnType<typeof useGetCellStockDeliveryQuery>["refetch"];
  error: ReturnType<typeof useGetCellStockDeliveryQuery>["error"];
} {
  const {
    data: rawData,
    refetch,
    error,
  } = useGetCellStockDeliveryQuery(arg, options);
  const data = useMemo(() => {
    if (isNullish(rawData)) return null;
    return cellStockDeliveryMeta.toSavedDomainObjectOrNull(
      rawData,
      skipOptionalValidations,
    );
  }, [rawData, skipOptionalValidations]);
  return { data, refetch, error };
}
